export default __webpack_public_path__ + "static/media/Sky-Davis.9541221c.jpg";